module.exports = __webpack_public_path__ + "static/media/qa.41c98331.svg";